import { useLocation } from 'react-router-dom';

export function useIsOnExplore() {
  const location = useLocation();
  return location.pathname.startsWith('/explore');
}
